
import SectionTitle from '~/sections/vision/section-title.vue'

export default {
  name: 'VisionStrategy',
  components: {
    SectionTitle
  },
  mounted() {
    this.syncDescriptionHeights()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    syncDescriptionHeights() {
      this.$nextTick(() => {
        const nodes = this.$el.querySelectorAll('.strategy__service__item__description')
        if (!nodes || nodes.length === 0) {
          return
        }
        const width = window.innerWidth
        if (width < 960) {
          nodes.forEach((n) => {
            n.style.height = 'auto'
          })
          return
        }
        nodes.forEach((n) => {
          n.style.height = 'auto'
        })
        let max = 0
        nodes.forEach((n) => {
          const h = n.getBoundingClientRect().height
          if (h > max) {
            max = h
          }
        })
        const heightPx = `${Math.ceil(max)}px`
        nodes.forEach((n) => {
          n.style.height = heightPx
        })
      })
    },
    onResize() {
      this.syncDescriptionHeights()
    }
  }
}
